import { useState, useRef, useEffect } from "react";
import { Image, Header, Placeholder, Button } from "semantic-ui-react";
import Img1 from "../assets/images/merch/Keep moving.png";

export default function CompetitionsCards(props) {
    const imgRef = useRef(null);
    const [state, setState] = useState(false);

    const onImageLoaded = () => setState(true);

    useEffect(() => {
        const imgElCurrent = imgRef.current;

        if (imgElCurrent) {
            imgElCurrent.addEventListener("load", onImageLoaded);
            return () => imgElCurrent.removeEventListener("load", onImageLoaded);
        }
    }, [imgRef]);

    const { photo, price, originalPrice,name,setShow } = props;
    return (
        <div className="col-lg-6 col-12">
            <div className="merch-cards">
                <img className={'merch-photo'} src={photo}/>
                <h2 className={'merch-name'}>
                    {name}
                </h2>
                <h3>
                    Price:
                    <strike>{`Rs. ${originalPrice}`}</strike>&nbsp;Rs. {price}
                </h3>
                <div className={'button-div'}>
                    <a className="btn-grad" target={'_blank'} href="https://forms.gle/VDAqdARA7xh4SrNy7">Buy Now !</a>
                </div>
                <button onClick={()=>setShow(true)} className={'size-chart'}>
                    Size Chart
                </button>
                <h6>
                    Free Home Delivery
                </h6>
            </div>
        </div>
    );
}
